import { render, staticRenderFns } from "./VueEditor.vue?vue&type=template&id=27e94fc7"
import script from "./VueEditor.vue?vue&type=script&lang=js"
export * from "./VueEditor.vue?vue&type=script&lang=js"
import style0 from "quill/dist/quill.snow.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./assets/vue2-editor.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports